import { render } from "./ToggleSidebarButton.vue?vue&type=template&id=196f8752"
import script from "./ToggleSidebarButton.vue?vue&type=script&lang=js"
export * from "./ToggleSidebarButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__